// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/app/app.scss
// module id = 497
// module chunks = 0